import { organizationClient } from "better-auth/client/plugins";
import { createAuthClient } from "better-auth/react";
import { getAppBaseUrl } from "@/lib/shared/deployment";

const getBaseURL = () => {
  if (typeof window !== "undefined") {
    return window.location.origin;
  }

  return getAppBaseUrl();
};

export const authClient: ReturnType<typeof createAuthClient> = createAuthClient(
  {
    baseURL: getBaseURL(),
    plugins: [organizationClient()],
  },
);

// Export hooks for use in components
export const { useSession } = authClient;
